export default __webpack_public_path__ + "static/media/Diaspora.ff5828e5.jpeg";